/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

import { getOCRProps } from "./components";

const is = require("is_js");

const SERVICE_NAME = "FullProvenancePageService";
const log: any = LoggerModule.getInstance();

export class GetOCRPageService {
  private static instance: GetOCRPageService;
  private vapp: VApplication;
  private getOCRRestAPI: string;
  //private headers : HeaderProps;
  public ageConfirm: boolean = false;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
    this.getOCRRestAPI = props?.getOCRRestAPI;
    //this.headers = props?.headers;
  }

  public static getInstance(props: any = {}): GetOCRPageService {
    if (!GetOCRPageService.instance) {
      GetOCRPageService.instance = new GetOCRPageService(props);
    }
    return GetOCRPageService.instance;
  }

  //private instances


  //------------------------------------

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async getOCR(args: getOCRProps) {
    console.log(` in index of service :`, args);
    let _args = {
      ...args,
      apiURL: this.getOCRRestAPI
    };
    const agent = getAgent();
    return agent.getOCR(_args);
  }
}
